import { TableCell, TableRow, Tooltip, Chip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UomType } from '../../../app/services/api/orderManagementClient';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  uomType: UomType;
};

const UomTypeItemRow: FC<Props> = ({ uomType }) => {
  const { t } = useTranslation('uomTypes');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['UomTypeUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/uom-types/edit/${uomType.uomTypeId}`);
  };

  const truncateText = (text: string, maxLength: number = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const renderBooleanChip = (value: boolean | undefined, trueLabel: string, falseLabel: string) => {
    if (value === undefined) return '-';
    
    return (
      <Chip
        label={value ? trueLabel : falseLabel}
        color={value ? 'success' : 'default'}
        size="small"
        variant={value ? 'filled' : 'outlined'}
      />
    );
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip 
          title={uomType.uomName} 
          placement="top"
        >
          <span>{truncateText(uomType.uomName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={uomType.instanceName} 
          placement="top"
        >
          <span>{truncateText(uomType.instanceName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={uomType.uomCode} 
          placement="top"
        >
          <span>{truncateText(uomType.uomCode)}</span>
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        {renderBooleanChip(uomType.isMeasurement, t('yes'), t('no'))}
      </TableCell>
      <TableCell align="center">
        {renderBooleanChip(uomType.isBase, t('yes'), t('no'))}
      </TableCell>
      <TableCell align="center">
        {renderBooleanChip(uomType.isSystemUom, t('yes'), t('no'))}
      </TableCell>
    </TableRow>
  );
};

export default UomTypeItemRow;
